module.exports = __webpack_public_path__ + "static/media/06en.ddc585cd.jpg";